import { firestore } from "@/api/firebase/firebase.config";

export async function _updateFirebaseProfileDoc(
  collectionName: string,
  docId: string,
  tenant: string,
  data: Record<string, any>
) {
  await firestore
    .collection(collectionName)
    .doc(tenant)
    .collection("records")
    .doc(docId)
    .update({
      ...data,
    });
}
